import React from 'react';

const AboutUs = () => {
  return (
    <section className="bg-[#F37920] text-white py-4 sm:py-2">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        <h2 className="text-xl sm:text-2xl font-semibold mb-2 sm:mb-4">
          Who We Are
        </h2>
        
        <h1 className="text-3xl sm:text-5xl font-bold">
          About Us
        </h1>

      </div>
    </section>
  );
};

export default AboutUs;
